import * as React from "react";
import { Dimensions, FlatList, StyleSheet, Text, View } from "react-native";
import { globalFontStyle, globalStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from "../../../components/core/Button";
import { useSelector } from "react-redux";
import { globalImport } from "../../../common/globalImports";
import Width from "../../../assets/Width";
import { isMobile } from "../../../utils/commonMethods";
import { useNavigation } from "@react-navigation/native";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const CryptoNetworkDetails = ({ details, withDrawConfirmBtnClick }) => {
  const navigation = useNavigation();
  const ref = React.useRef(null);
  let globalConfigData = useSelector(
    (state) => state.utilReducer.globalConfigData
  );

  var width = !isMobile() ? ref?.current?.offsetWidth : Width.width - 20;

  const confirmButtonClick = () => {
    if (!expired) {
      if (isMobile()) {
        navigation.pop();
      }
      withDrawConfirmBtnClick(details);
    }
  };

  const [time, setTime] = React.useState(globalConfigData?.withdrawTimer || 45);
  const timerRef = React.useRef(time);

  const [expired, setExpired] = React.useState(false);

  React.useEffect(() => {
    const timerId = setInterval(() => {
      timerRef.current -= 1;
      if (timerRef.current < 0) {
        setExpired(true);
        clearInterval(timerId);
      } else {
        setTime(timerRef.current);
      }
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);

  return (
    <>
      <View
        ref={ref}
        style={{
          //paddingHorizontal: 10,
          paddingVertical: 10,
          //width: width,
          flex: 1,
          //justifyContent: "flex-start",
        }}
      >
        <View
          style={{
            borderColor: Colors.grey6,
            borderWidth: 1,
            borderRadius: 10,
          }}
        >
          <FlatList
            scrollEnabled
            data={details?.fields}
            renderItem={(itemList, index) => {
              return (
                <View>
                  <View style={{ padding: 10 }}>
                      <FormTextLabel
                        label={itemList?.item?.label}
                        labelStyles={styles.label}
                      />
                      <FormTextLabel
                          label={itemList?.item?.value}
                          labelStyles={{
                              //marginTop: 5,
                              ...globalFontStyle.appFontHeadingRegular,
                          }}
                      />
                  </View>
                  <View
                    style={{
                      borderBottomColor: Colors.grey6,
                      borderBottomWidth: 1,
                      //marginTop: 5,
                      //marginLeft: -20,
                      //marginRight: -20,
                    }}
                  />
                </View>
              );
            }}
            //onRefresh={PullToRefresh}
            //refreshing={loading}
            //keyExtractor={(item, index) => index}
            showsVerticalScrollIndicator={false}
            initialNumToRender={10}
          />
        </View>

        <View
          style={{
            //flex: 1,
            //paddingLeft: 20,
            //paddingRight: 20,
            width: "100%",
            paddingTop: 10,
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <FormTextLabel
            label={"The exchange rate is valid for "}
            labelStyles={[globalFontStyle.appFontSmallText, { color: Colors.grey2 }]}
          />
            <FormTextLabel
                label={" 00 : "}
                rest={{time: time}}
                labelStyles={[
                    globalFontStyle.appFontSmallText,
                    { color: Colors.tradexBlue },
                ]}
            />
        </View>
        <View
          style={[
            globalStyle.bottomAbsBtnBar,
            isMobile() ? null : { position: "initial" },
            { width: width },
          ]}
        >
          <Button
            translate={true}
            variant={expired ? "disabled" : "primary"}
            onPress={confirmButtonClick}
            style={{ flex: 1, marginTop: 15 }}
            disabled={expired}
          >
            {expired ? "Details Expired" : "Confirm"}
          </Button>
        </View>
      </View>
    </>
  );
};

export default CryptoNetworkDetails;

const styles = StyleSheet.create({
  addBankNote: {
    ...globalFontStyle.appFontSmallTextBold,
    color: Colors.black,
    marginBottom: 30,
  },
  addBankNote1: {
    ...globalFontStyle.appSmall10,
    color: Colors.tradexBlue,
    textAlign: "center",
    marginTop: 30,
  },
  label: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.grey1,
  },
  errTitle: {
    ...globalFontStyle.appFontSubHeading,
    color: Colors.black,
    textAlign: "center",
  },
  errNote: {
    ...globalFontStyle.appSmall10,
    color: Colors.black,
    textAlign: "center",
  },
  errSubtitle: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.black,
    marginBottom: 40,
    textAlign: "center",
  },
});
